import { datadogRum } from '@datadog/browser-rum';
import { ChargeDetails } from '@/views/checkout/components/charge-dialog/interfaces';

function sanitizeChargeDetails(chargeDetails: ChargeDetails, correlationId: string | undefined) {
    return {
        correlationId,
        bankId: chargeDetails.bankId,
        maskedNumber: chargeDetails.maskedNumber
    };
}

export function setDatadogChargeDetailsFlow(flowType: string,
    chargeDetails: ChargeDetails,
    correlationId: string | undefined) {
    datadogRum.setGlobalContextProperty(`chargeDetails_${flowType}`, sanitizeChargeDetails(chargeDetails, correlationId));
}

export function setDatadogOrderCode(orderCode: string) {
    datadogRum.setGlobalContextProperty('orderCode', orderCode);
}
